import { TsEvent } from './trade-system.model';
import { TsName } from './ts-proxy.service';

const TRADE_SYSTEM_TITLES: Record<TsName, string> = {
  privod_bondar: 'Privod Bondar',
  prop_broker: 'Prop Broker',
}

const TRADE_SYSTEM_SHORT_TITLES: Record<TsName, string> = {
  privod_bondar: 'Privod',
  prop_broker: 'PB',
}

export function getTradeSystemTitle(tsName: TsName) {
  return TRADE_SYSTEM_TITLES[tsName]
}

export function getTradeSystemShortTitle(tsName: TsName) {
  return TRADE_SYSTEM_SHORT_TITLES[tsName]
}

export function getTradeSystemEventKey(event: TsEvent): string {
  return JSON.stringify([
    event.tsName,
    event.evUid ?? [
      event.moment,
      event.exchCode,
      event.evType,
      event.accName,
      event.secBoard,
      event.secCode,
      event.price,
      event.amount,
      event.errCode,
      event.message,
    ],
  ]);
}
